import apiClient from './api';
import { WarehouseTransfer, CreateWarehouseTransferDto, UpdateWarehouseTransferDto } from '../types/warehouseTransfers.types';

export const warehouseTransfersService = {
  // ✅ NEW: جلب كل المخازن بدون فلترة فروع — للقوائم المنسدلة
  async getAllWarehousesForLookup(): Promise<any[]> {
    const response = await apiClient.get('/Warehouses/lookup');
    return response.data;
  },

  async getAll(
    status?: string,
    fromWarehouseId?: number,
    toWarehouseId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<WarehouseTransfer[]> {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (fromWarehouseId) params.append('fromWarehouseId', fromWarehouseId.toString());
    if (toWarehouseId) params.append('toWarehouseId', toWarehouseId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);

    const query = params.toString();
    const response = await apiClient.get(`/WarehouseTransfers${query ? `?${query}` : ''}`);
    return response.data;
  },

  async getById(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.get(`/WarehouseTransfers/${id}`);
    return response.data;
  },

  async create(data: CreateWarehouseTransferDto): Promise<WarehouseTransfer> {
    const response = await apiClient.post('/WarehouseTransfers', data);
    return response.data;
  },

  async update(id: number, data: UpdateWarehouseTransferDto): Promise<WarehouseTransfer> {
    const response = await apiClient.put(`/WarehouseTransfers/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`/WarehouseTransfers/${id}`);
  },

  // ✅ NEW: موافقة أمين المخزن — Pending/Rejected → Draft
  async approve(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/approve`);
    return response.data;
  },

  // ✅ NEW: رفض أمين المخزن — Pending → Rejected
  async reject(id: number, reason?: string): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/reject`, { reason });
    return response.data;
  },

  async ship(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/ship`);
    return response.data;
  },

  // ✅ NEW: إلغاء الشحن — InTransit → Draft
  async cancelShip(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/cancel-ship`);
    return response.data;
  },

  async receive(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/receive`);
    return response.data;
  },

  // ✅ NEW: إلغاء الاستلام — Received → InTransit (Super Admin only)
  async cancelReceive(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/cancel-receive`);
    return response.data;
  },

  async post(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/post`);
    return response.data;
  },

  async unpost(id: number): Promise<WarehouseTransfer> {
    const response = await apiClient.post(`/WarehouseTransfers/${id}/unpost`);
    return response.data;
  },

  async generateTransferNumber(): Promise<string> {
    const response = await apiClient.get('/WarehouseTransfers/generate-transfer-number');
    return response.data;
  },

  async getAvailableStock(itemId: number, unitId: number, warehouseId: number): Promise<any> {
    const response = await apiClient.get(
      `/WarehouseTransfers/available-stock?itemId=${itemId}&unitId=${unitId}&warehouseId=${warehouseId}`
    );
    return response.data;
  },
};